var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      ref: "offcanvasElement",
      staticClass: "offcanvas offcanvas-start",
      attrs: {
        tabindex: "-1",
        id: "contentTypeFieldsetOffcanvas",
        "aria-labelledby": "contentTypeFieldsetOffcanvasLabel",
      },
    },
    [
      _c("div", { staticClass: "offcanvas-header" }, [
        _c(
          "h5",
          {
            staticClass: "offcanvas-title",
            attrs: { id: "contentTypeFieldsetOffcanvasLabel" },
          },
          [_vm._v(_vm._s(_setup.title))]
        ),
        _vm._v(" "),
        _c("button", {
          staticClass: "btn-close",
          attrs: {
            type: "button",
            "data-bs-dismiss": "offcanvas",
            "aria-label": "Close",
          },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "offcanvas-body" }, [
        _c(
          "form",
          {
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return _setup.handleSubmit.apply(null, arguments)
              },
            },
          },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _setup.formData.legend,
                  expression: "formData.legend",
                },
              ],
              ref: "legendInput",
              staticClass: "form-control",
              attrs: { name: "legend", placeholder: "Legend" },
              domProps: { value: _setup.formData.legend },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_setup.formData, "legend", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "mt-3 d-flex" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  attrs: { type: "submit", disabled: !_setup.formData.legend },
                },
                [_vm._v("\n                    Save\n                ")]
              ),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "p-3 text-end" }, [
        _setup.fieldsetId
          ? _c(
              "button",
              {
                staticClass: "btn btn-danger",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _setup.deleteFieldset.apply(null, arguments)
                  },
                },
              },
              [_vm._v("\n            Delete\n        ")]
            )
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }